export default __webpack_public_path__ + "media/images/preview-72bc97c2262de26b5b280ad4407f8f77.png";